import { useParams , useNavigate } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import background_image from "../assets/bg10.jpg"
import logo_image from "../assets/logo-immens.svg"
import custom_image from "../assets/buss.jpg"
import "../pages/activation.css"


export default function Activation(props) {


    const { verification_code, Cod_fiscal, Email } = useParams();
    const [isActivated,setIsActivated]=useState(false);
    
    async function activate_user(code,cod_vat,email) {
        console.log(code);
        console.log(cod_vat);
        console.log(email);
        await fetch(`/api/companies/activate/${code}/${cod_vat}/${email}`,
            {
                method: 'GET',
            }).then((response) => {
                console.log(response);
                if (response.ok) setIsActivated(true)
            });

    }


    useEffect(() => {
        activate_user(verification_code,Cod_fiscal,Email)
    }, [])

    return (
        <React.Fragment>
            <div className="background-div ">
            <div className="text-center" >
                <div className="row w-100" style={{'height':'25rem'}}>
                    <img className="mx-auto d-block" src={logo_image} alt="" style={{'height':'100px','width':'300px','margin-top':'50px'}} />
                </div>
                {
                    isActivated ?(
                        <div className="h-25 d-inline-block text-center" style={{'height':'30rem'}}>
                        <h2 className="title" style={{'margin':'10px'}}>Contul dumneavoastra a fost activat cu succes </h2>
                        <h3>
                            <small className="text-muted">Pentru mai multe detalii nu ezitati sa ne contactati la adresa contact@alzavision.ro</small>
                        </h3>
                        <h6>
                            <small className="text-muted">Multumim! &copy;Immens Team</small>
                        </h6>
                    </div>
                    ) :
                    (
                        <div className="h-25 d-inline-block text-center" style={{'height':'30rem'}}>
                        <h2 className="title" style={{'margin':'10px'}}>A intervenit o eroare. Link-ul furnizat este incorect. </h2>
                        <h3>
                            <small className="text-muted">Pentru mai multe detalii nu ezitati sa ne contactati la adresa contact@alzavision.ro</small>
                        </h3>
                        <h6>
                            <small className="text-muted">Multumim! &copy;Immens Team</small>
                        </h6>
                    </div>
                    )
                }
                
            </div>
            </div>
        </React.Fragment>
    )
}